var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Exclude, Expose } from 'class-transformer';
import { IsDateString, IsUUID } from 'class-validator';
import { Gewinnermittlungsart, Kontenrahmen, Versteuerungsart } from '../types/datev-enums.js';
/**
 * Read shape for the OfficeLocation DATEV settings sidebar. Mirrors the
 * domain aggregate's persisted state. `kontenMapping` always carries
 * Kontenrahmen-appropriate defaults — never `null` — so the foldout can
 * render edit fields without a "not configured" branch.
 *
 * `fiscalYearStart` is encoded as `"MM-DD"` (e.g. `"01-01"`); the year and
 * timezone are intentionally absent because the fiscal-year boundary is a
 * calendar concept consumed verbatim in EXTF headers.
 */
export class OfficeLocationDatevSettingsResponseDto {
    id;
    createdAt;
    updatedAt;
    officeLocationId;
    beraternummer;
    mandantennummer;
    /** `"MM-DD"` — calendar day on which the fiscal year starts. */
    fiscalYearStart;
    foundingDate;
    sachkontenlaenge;
    kontenrahmen;
    gewinnermittlungsart;
    versteuerungsart;
    kontenMapping;
    /**
     * `true` iff `assertDatevExportable()` would pass on the current state.
     * The frontend uses this to show a "ready for export" badge on the
     * settings sidebar; the actual generate-export use case re-checks the
     * invariant server-side.
     */
    isExportable;
    /**
     * `true` once the first DATEV export has completed for this OfficeLocation
     * (PRD #1319 / RS-003). While frozen, every settings change requires an
     * explicit recorded reason. The UI renders a lock badge and routes saves
     * through a reason modal.
     */
    isFrozen;
    /**
     * ISO timestamp of the first completed export, or `null` if none. Drives
     * the freeze-date shown in the lock badge. Set once server-side, never
     * cleared.
     */
    firstExportedAt;
}
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], OfficeLocationDatevSettingsResponseDto.prototype, "id", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    __metadata("design:type", Date)
], OfficeLocationDatevSettingsResponseDto.prototype, "createdAt", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    __metadata("design:type", Date)
], OfficeLocationDatevSettingsResponseDto.prototype, "updatedAt", void 0);
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], OfficeLocationDatevSettingsResponseDto.prototype, "officeLocationId", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], OfficeLocationDatevSettingsResponseDto.prototype, "beraternummer", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], OfficeLocationDatevSettingsResponseDto.prototype, "mandantennummer", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], OfficeLocationDatevSettingsResponseDto.prototype, "fiscalYearStart", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], OfficeLocationDatevSettingsResponseDto.prototype, "foundingDate", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], OfficeLocationDatevSettingsResponseDto.prototype, "sachkontenlaenge", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], OfficeLocationDatevSettingsResponseDto.prototype, "kontenrahmen", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], OfficeLocationDatevSettingsResponseDto.prototype, "gewinnermittlungsart", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], OfficeLocationDatevSettingsResponseDto.prototype, "versteuerungsart", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], OfficeLocationDatevSettingsResponseDto.prototype, "kontenMapping", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Boolean)
], OfficeLocationDatevSettingsResponseDto.prototype, "isExportable", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Boolean)
], OfficeLocationDatevSettingsResponseDto.prototype, "isFrozen", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], OfficeLocationDatevSettingsResponseDto.prototype, "firstExportedAt", void 0);
//# sourceMappingURL=office-location-datev-settings.response.dto.js.map